import { useState } from 'react';
import DeleteOptions from './DeleteOptions';
import SearchBar from './SearchBar';

const ListHeader: React.FC<{
  showDelete: boolean;
  setShowDelete: (showDelete: boolean) => void;
  onSearch: (value: string) => void;
  allChecked: boolean;
  setAllChecked: (allChecked: boolean) => void;
  onBatchDelete: () => void;
  canDelete: boolean;
}> = ({
  showDelete,
  setShowDelete,
  onSearch,
  allChecked,
  setAllChecked,
  onBatchDelete,
  canDelete,
}) => {
  const [searchValue, setSearchValue] = useState<string>('');
  return (
    <div>
      {showDelete ? (
        <DeleteOptions
          allChecked={allChecked}
          setAllChecked={setAllChecked}
          onDelete={onBatchDelete}
          canDelete={canDelete}
          onExit={() => setShowDelete(false)}
        />
      ) : (
        <SearchBar
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          setShowDelete={setShowDelete}
          onSearch={onSearch}
        />
      )}
    </div>
  );
};

export default ListHeader;
